import React from "react";
import "jqwidgets-scripts/jqwidgets/jqxcore";
import "jqwidgets-scripts/jqwidgets/jqxdata";
import "jqwidgets-scripts/jqwidgets/jqxbuttons";
import "jqwidgets-scripts/jqwidgets/jqxscrollbar";
import "jqwidgets-scripts/jqwidgets/jqxmenu";
import "jqwidgets-scripts/jqwidgets/jqxgrid";
import "jqwidgets-scripts/jqwidgets/jqxgrid.sort";
import "jqwidgets-scripts/jqwidgets/jqxgrid.pager";
import "jqwidgets-scripts/jqwidgets/jqxgrid.filter";
import "jqwidgets-scripts/jqwidgets/jqxgrid.selection";

import JqxGrid from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css";
import "./CSS/Tags.css";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { dominio } from "../../../routes_backend/routes.jsx";


import {
  Grid,
  Col,
  Row,
  Button,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  Table,
  Alert,
} from "react-bootstrap";

import Card from "../../../components/Card/Card";
import Loading from "../../../views/Loading";

import "jqwidgets-scripts/jqwidgets/styles/jqx.ui-redmond.css";

// API-Key para el endpoint SGIM_ListaAlmacenes (lista de almacenes desde SAP)
const API_KEY_TAGS = "b4ed47a3-b372-49df-a200-2e68d5f7a454";

class Tags extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isSaving: false,
      message: "",
      dataAdapter: null,

      currentUserId: "",

      showCreateModal: false,
      isItemsLoading: false,
      availableItems: [],

      // Almacenes obtenidos desde SAP (endpoint SGIM_ListaAlmacenes)
      almacenesSAP: [],

      ubicaciones: {
        Estante: [],
        Seccion: [],
        Nivel: [],
        Almacen: [],
      },

      showUbicacionesModal: false,
      ubicacionesTab: "Estante",
      ubicacionForm: {
        id: null,
        valor: "",
      },
      isUbicacionesLoading: false,

      modalAlert: null,
      modalAlertVisible: false,

      queue: [],
      editingIndex: null,

      editingExistingTag: false,
      editingExistingTagId: null,

      docNumSearch: "",
      fetchedDocLines: [],

      existingTagsMap: {},
      tagsByItemAlmacen: {},

      // Selector de ubicación (cuando un código+almacén tiene varias ubicaciones existentes)
      showUbicacionPicker: false,
      pickerIndex: null,
      pickerOptions: [],

      form: {
        ItemCode: "",
        Dscription: "",
        Estante: "",
        Seccion: "",
        Nivel: "",
        Almacen: "",
        UserId: "",
      },
    };

    this.modalAlertTimer = null;
    this.modalAlertCloseTimer = null;

    this.gridRef = React.createRef();
  }

  componentDidMount() {
    this.loadData();
    this.loadUbicacionesTags();

    let userid = "";
    let usuariosap = "";
    let nombresap = "";
    let apellidosap = "";
    let NombreApellido = "";
    let token = localStorage.getItem("token");
    let token_Data = null;

    try {
      token_Data = JSON.parse(token);
    } catch (error) {
      token_Data = null;
    }

    if (token_Data !== null) {
      token_Data.forEach((element) => {
        userid = element.U_UserId;
        usuariosap = element.usuarioSAP;
        nombresap = element.Nombre;
        apellidosap = element.Apellido;
        NombreApellido = nombresap + " " + apellidosap;
      });
    }

    if (token_Data === null) {
      this.props.history.push("");
      return;
    }


    this.setState({
      currentUserId: String(userid || ""),
    });
  }

  componentWillUnmount() {
    if (this.modalAlertTimer) clearTimeout(this.modalAlertTimer);
    if (this.modalAlertCloseTimer) clearTimeout(this.modalAlertCloseTimer);
    this.modalAlertTimer = null;
    this.modalAlertCloseTimer = null;
  }

  // =========================
  // HELPERS: DUPLICADOS POR (ItemCode+Estante+Seccion+Nivel+Almacen)
  // =========================
  normalize = (v) => String(v ?? "").trim().toUpperCase();

  comboKey = (q) => {
    const item = this.normalize(q?.ItemCode);
    const est = this.normalize(q?.Estante);
    const sec = this.normalize(q?.Seccion);
    const niv = this.normalize(q?.Nivel);
    const alm = this.normalize(q?.Almacen);
    return item + "||" + est + "||" + sec + "||" + niv + "||" + alm;
  };

  buildLocationDescTag = (estante, seccion, nivel) => {
    const e = String(estante ?? "").trim();
    const s = String(seccion ?? "").trim();
    const n = String(nivel ?? "").trim();

    return [e, s, n].join(" - ");
  };

  recomputeDuplicates = (queue) => {
    const counts = new Map();
    queue.forEach((q) => {
      const key = this.comboKey(q);
      counts.set(key, (counts.get(key) || 0) + 1);
    });

    return queue.map((q) => {
      const key = this.comboKey(q);
      const dup = (counts.get(key) || 0) > 1;
      return { ...q, isDup: dup };
    });
  };

  anyDuplicatesInQueue = (queue) => {
    if (!queue || queue.length === 0) return false;
    const seen = new Set();
    for (const q of queue) {
      const key = this.comboKey(q);
      if (seen.has(key)) return true;
      seen.add(key);
    }
    return false;
  };

  getUniqueQueueRowsByCombo = (rows) => {
    const map = new Map();

    (rows || []).forEach((q) => {
      const key = this.comboKey(q);
      if (!map.has(key)) {
        map.set(key, q);
      }
    });

    return Array.from(map.values());
  };

  // =========================
  // HELPERS: SELECCIÓN / COPIAS / IMPRESIÓN
  // =========================
  hasTag = (q) => {
    const v = q?.number_tag;
    return v !== null && v !== undefined && String(v).trim() !== "";
  };

  sanitizeCopies = (v) => {
    const n = Number(v);
    if (Number.isNaN(n)) return 1;
    if (n < 1) return 1;
    if (n > 999) return 999;
    return Math.floor(n);
  };

  toggleQueueSelect = (index, checked) => {
    this.setState((prev) => {
      const q = [...(prev.queue || [])];
      if (!q[index]) return null;
      q[index] = { ...q[index], selected: checked };
      return { queue: q };
    });
  };

  toggleSelectAllQueue = (checked) => {
    this.setState((prev) => ({
      queue: (prev.queue || []).map((q) => ({ ...q, selected: checked })),
    }));
  };

  setQueueCopies = (index, value) => {
    const copies = this.sanitizeCopies(value);
    this.setState((prev) => {
      const q = [...(prev.queue || [])];
      if (!q[index]) return null;
      q[index] = { ...q[index], copies };
      return { queue: q };
    });
  };

  // =========================================================
  // IMPRESIÓN: COLA
  // =========================================================
  printSelectedFromQueueSingleWindow = () => {
    const { queue } = this.state;
    const selected = (queue || []).filter((q) => q.selected);

    if (selected.length === 0) {
      this.setModalAlert("warning", "No hay filas seleccionadas para imprimir.");
      return;
    }

    const withTag = selected.filter((q) => this.hasTag(q));
    const withoutTag = selected.filter((q) => !this.hasTag(q));

    if (withTag.length === 0) {
      this.setModalAlert("warning", "Las filas seleccionadas no tienen Tag (number_tag).");
      return;
    }

    const jobs = [];
    withTag.forEach((q) => {
      const c = this.sanitizeCopies(q.copies ?? 1);
      for (let i = 0; i < c; i++) {
        jobs.push({
          barcodeValue: String(q.number_tag || ""),
          itemCode: String(q.ItemCode || ""),
          desc: String(q.Dscription || ""),
          loc: String(q.location_desc_tag || ""),
          almacen: String(q.Almacen || ""),
          docDate: q.docDate ?? null,
        });
      }
    });

    if (withoutTag.length > 0) {
      this.setModalAlert(
        "info",
        "Se imprimirán " +
          jobs.length +
          " etiquetas. " +
          withoutTag.length +
          " seleccionados no tienen Tag y se ignoraron."
      );
    } else {
      this.setModalAlert("success", "Se imprimirán " + jobs.length + " etiquetas...");
    }

    const w = window.open("", "_blank");
    if (!w) {
      this.setModalAlert("danger", "El navegador bloqueó el popup. Permití popups para este sitio.");
      return;
    }

    const dataJson = JSON.stringify(jobs);

    w.document.write(`
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Imprimir Tags</title>
          <style>
            @page { size: 29.9mm 18mm; margin: 0; }

            html, body {
              width: 29.9mm;
              height: 18mm;
              margin: 0;
              padding: 0;
              background: #fff;
            }

            body {
              font-family: Tahoma, Verdana, Segoe UI, Arial, sans-serif;
            }

            .toolbar {
              display: flex;
              gap: 8px;
              justify-content: center;
              margin: 10px 0;
            }

            .page {
              width: 29.9mm;
              height: 18mm;
              margin: 0;
              padding: 0;
              page-break-after: always;
              break-after: page;
            }

            .page:last-child {
              page-break-after: auto;
              break-after: auto;
            }

            .label {
              width: 29.9mm;
              height: 18mm;
              margin: 0;
              padding: 0.15mm 0.35mm 0.15mm 0.35mm;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              text-align: center;
              overflow: hidden;
            }

            .barcode-wrap {
              width: 100%;
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: flex-start;
            }

            svg {
              width: 28.9mm;
              height: 6.4mm;
              display: block;
              margin: 0;
              padding: 0;
            }

            .line {
              width: 100%;
              margin: 0;
              padding: 0;
              text-align: center;
              overflow: hidden;
            }

            .line-tag {
              font-size: 8pt;
              line-height: 0.98;
              font-weight: 700;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-top: -0.15mm;
              margin-bottom: 0.25mm;
            }

            .line-desc {
              font-size: 6.5pt;
              line-height: 0.98;
              font-weight: 400;
              white-space: normal;
              word-break: break-word;
              overflow: hidden;
              text-overflow: clip;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              min-height: 4.0mm;
              max-height: 4.0mm;
              margin-bottom: 0.1mm;
            }

            .line-loc {
              font-size: 6.9pt;
              line-height: 0.98;
              font-weight: 700;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-top: 0.1mm;
            }

            .line-date {
              font-size: 5.5pt;
              line-height: 0.98;
              font-weight: 400;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 0.1mm;
            }

            @media print {
              .toolbar { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="toolbar">
            <button id="btnPrint">Imprimir</button>
            <button id="btnClose">Cerrar</button>
          </div>

          <div id="container"></div>

          <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>
          <script>
            const jobs = ${dataJson};
            const container = document.getElementById("container");

            function safeText(t) {
              return (t === null || t === undefined) ? "" : String(t);
            }

            function formatDate(d) {
              if (!d) return "";
              try {
                var dt = new Date(d);
                if (isNaN(dt.getTime())) return String(d);
                var day = String(dt.getUTCDate()).padStart(2, "0");
                var mon = String(dt.getUTCMonth() + 1).padStart(2, "0");
                var year = dt.getUTCFullYear();
                return day + "/" + mon + "/" + year;
              } catch(e) { return String(d || ""); }
            }

            function fitDescription(el) {
              if (!el) return;

              let fontSize = 6.5;
              el.style.fontSize = fontSize + "pt";

              while (fontSize > 4.8 && el.scrollHeight > el.clientHeight) {
                fontSize -= 0.2;
                el.style.fontSize = fontSize + "pt";
              }
            }

            jobs.forEach((j, idx) => {
              const id = "barcode-" + idx;
              const descId = "desc-" + idx;

              const page = document.createElement("div");
              page.className = "page";

              const label = document.createElement("div");
              label.className = "label";

              label.innerHTML = \`
                <div class="barcode-wrap">
                  <svg id="\${id}"></svg>
                </div>
                <div class="line line-tag">\${safeText(j.itemCode)}</div>
                <div class="line line-desc" id="\${descId}">\${safeText(j.desc)}</div>
                <div class="line line-loc">\${safeText(j.loc)}\${j.almacen ? "   " + safeText(j.almacen) : ""}</div>
                <div class="line line-date">\${formatDate(j.docDate)}</div>
              \`;

              page.appendChild(label);
              container.appendChild(page);
            });

            jobs.forEach((j, idx) => {
              try {
                JsBarcode("#barcode-" + idx, safeText(j.barcodeValue), {
                  format: "CODE128",
                  displayValue: false,
                  margin: 0,
                  marginTop: 0,
                  marginBottom: 0,
                  height: 24,
                  width: 1
                });
              } catch (e) {}
            });

            jobs.forEach((j, idx) => {
              fitDescription(document.getElementById("desc-" + idx));
            });

            function waitForRender() {
              return new Promise(resolve => {
                requestAnimationFrame(() => requestAnimationFrame(resolve));
              });
            }

            const btnPrint = document.getElementById("btnPrint");
            const btnClose = document.getElementById("btnClose");

            btnPrint.addEventListener("click", async () => {
              btnPrint.disabled = true;
              try {
                window.focus();
                await waitForRender();
                setTimeout(() => window.print(), 120);
              } finally {
                setTimeout(() => { btnPrint.disabled = false; }, 1200);
              }
            });

            btnClose.addEventListener("click", () => window.close());
          </script>
        </body>
      </html>
    `);

    w.document.close();
    w.focus();
  };

  // ====== ALERTAS MODAL ======
  setModalAlert = (type, text) => {
    if (this.modalAlertTimer) {
      clearTimeout(this.modalAlertTimer);
      this.modalAlertTimer = null;
    }
    if (this.modalAlertCloseTimer) {
      clearTimeout(this.modalAlertCloseTimer);
      this.modalAlertCloseTimer = null;
    }

    this.setState({ modalAlert: { type, text }, modalAlertVisible: true }, () => {
      this.modalAlertTimer = setTimeout(() => {
        this.hideModalAlertAnimated();
      }, 2000);
    });
  };

  hideModalAlertAnimated = () => {
    this.setState({ modalAlertVisible: false });
    this.modalAlertCloseTimer = setTimeout(() => {
      this.setState({ modalAlert: null });
      this.modalAlertCloseTimer = null;
    }, 230);
  };

  clearModalAlert = () => {
    if (this.modalAlertTimer) {
      clearTimeout(this.modalAlertTimer);
      this.modalAlertTimer = null;
    }
    if (this.modalAlertCloseTimer) {
      clearTimeout(this.modalAlertCloseTimer);
      this.modalAlertCloseTimer = null;
    }

    if (this.state.modalAlert) this.hideModalAlertAnimated();
    else this.setState({ modalAlertVisible: false });
  };

  // ====== GRID DATA ======
  loadData = async () => {
    this.setState({ isLoading: true, message: "" });

    try {
      //const res = await fetch(`${dominio}/getTags`);
      const res = await fetch(`${dominio}/getTags`);
      if (!res.ok) throw new Error("HTTP " + res.status);
      const data = await res.json();

      const source = {
        datatype: "array",
        localdata: data,
        datafields: [
          { name: "ItemCode", type: "string" },
          { name: "Dscription", type: "string" },
          { name: "number_tag", type: "string" },
          { name: "location_desc_tag", type: "string" },
          { name: "fechaCreacion", type: "date" },
          { name: "fechaModificacion", type: "date" },
          { name: "Estante", type: "string" },
          { name: "Seccion", type: "string" },
          { name: "Nivel", type: "string" },
          { name: "Almacen", type: "string" },
          { name: "UserId", type: "number" },
        ],
      };

      const dataAdapter = new window.jqx.dataAdapter(source);
      this.setState({ dataAdapter, isLoading: false, message: "" });
    } catch (err) {
      this.setState({
        message: "Error cargando tags: " + (err?.message || "Error"),
        isLoading: false,
        dataAdapter: null,
      });
    }
  };

  // ====== MAPA DE TAGS EXISTENTES ======
  loadExistingTagsMap = async () => {
    try {
      const res = await fetch(`${dominio}/getTags`);
      if (!res.ok) throw new Error("HTTP " + res.status);
      const data = await res.json();

      // Clave por la combinación COMPLETA (ItemCode + Estante + Sección + Nivel + Almacén),
      // igual que la regla de unicidad (comboKey). Un mismo artículo puede tener
      // tags en distintas ubicaciones y/o almacenes.
      const map = {};        // clave = comboKey completo (ItemCode+Estante+Sección+Nivel+Almacén)
      const byItemAlm = {};  // clave = ItemCode||Almacén -> lista de tags (para autoubicar solo si es único)
      (Array.isArray(data) ? data : []).forEach((t) => {
        if (!t?.ItemCode) return;
        map[this.comboKey(t)] = t;
        const k = this.normalize(t.ItemCode) + "||" + this.normalize(t.Almacen);
        if (!byItemAlm[k]) byItemAlm[k] = [];
        byItemAlm[k].push(t);
      });

      this.setState({ existingTagsMap: map, tagsByItemAlmacen: byItemAlm });
      return { map, byItemAlm };
    } catch (err) {
      this.setState({ message: "No se pudo cargar mapa de tags existentes: " + (err?.message || "Error") });
      return { map: {}, byItemAlm: {} };
    }
  };

  // ====== ITEMS FOR COMBO ======
  loadAvailableItems = async () => {
    this.setState({ isItemsLoading: true });

    try {
      const res = await fetch(`${dominio}/getArticulosTags`);
      if (!res.ok) throw new Error("HTTP " + res.status);
      const items = await res.json();

      this.setState({ availableItems: items || [], isItemsLoading: false });
    } catch (err) {
      this.setState({
        message: "Error cargando items (HANA): " + (err?.message || "Error"),
        availableItems: [],
        isItemsLoading: false,
      });
    }
  };


  // ====== ALMACENES DESDE SAP (solo lectura) ======
  loadAlmacenesSAP = async () => {
    try {
      const res = await fetch(`${dominio}/SGIM_ListaAlmacenes`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "API-Key": API_KEY_TAGS,
        },
      });
      if (!res.ok) throw new Error("HTTP " + res.status);
      const data = await res.json();
      const list = Array.isArray(data) ? data : data?.data || [];
      this.setState({ almacenesSAP: list });
    } catch (err) {
      this.setState({ almacenesSAP: [] });
    }
  };

  // ====== UBICACIONES TAGS: ESTANTE / SECCION / NIVEL ======
  getUbicacionIdField = (tabla) => {
    if (tabla === "Estante") return "idEstante";
    if (tabla === "Seccion") return "idSeccion";
    if (tabla === "Nivel") return "idNivel";
    if (tabla === "Almacen") return "idAlmacen";
    return "id";
  };

  getUbicacionValueField = (tabla) => {
    if (tabla === "Estante") return "Estante";
    if (tabla === "Seccion") return "Seccion";
    if (tabla === "Nivel") return "Nivel";
    if (tabla === "Almacen") return "Almacen";
    return "valor";
  };

  loadUbicacionByTabla = async (tabla) => {
    const res = await fetch(`${dominio}/UbicacionesTags`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        accion: "get",
        tabla: tabla,
      }),
    });

    const body = await res.json().catch(() => []);

    if (!res.ok) {
      throw new Error(body?.error || "Error cargando " + tabla);
    }

    return Array.isArray(body) ? body : [];
  };

  loadUbicacionesTags = async () => {
    this.setState({ isUbicacionesLoading: true });

    try {
      const [estantes, secciones, niveles] = await Promise.all([
        this.loadUbicacionByTabla("Estante"),
        this.loadUbicacionByTabla("Seccion"),
        this.loadUbicacionByTabla("Nivel"),
      ]);

      this.setState({
        ubicaciones: {
          Estante: estantes,
          Seccion: secciones,
          Nivel: niveles,
          Almacen: [],
        },
        isUbicacionesLoading: false,
      });
    } catch (err) {
      this.setState({
        isUbicacionesLoading: false,
        message: "Error cargando ubicaciones: " + (err?.message || "Error"),
      });

      Swal.fire({
        icon: "error",
        title: "Error cargando ubicaciones",
        text: err?.message || "No se pudieron cargar Estante, Sección y Nivel.",
        confirmButtonText: "Aceptar",
      });
    }
  };

  openUbicacionesModal = () => {
    this.setState(
      {
        showUbicacionesModal: true,
        ubicacionesTab: "Estante",
        ubicacionForm: {
          id: null,
          valor: "",
        },
      },
      () => {
        this.loadUbicacionesTags();
      }
    );
  };

  closeUbicacionesModal = () => {
    if (this.state.isUbicacionesLoading) return;

    this.setState({
      showUbicacionesModal: false,
      ubicacionForm: {
        id: null,
        valor: "",
      },
    });
  };

  changeUbicacionesTab = (tabla) => {
    this.setState({
      ubicacionesTab: tabla,
      ubicacionForm: {
        id: null,
        valor: "",
      },
    });
  };

  editUbicacion = (row) => {
    const { ubicacionesTab } = this.state;

    const idField = this.getUbicacionIdField(ubicacionesTab);
    const valueField = this.getUbicacionValueField(ubicacionesTab);

    this.setState({
      ubicacionForm: {
        id: row[idField],
        valor: row[valueField] || "",
      },
    });
  };

  clearUbicacionForm = () => {
    this.setState({
      ubicacionForm: {
        id: null,
        valor: "",
      },
    });
  };

  saveUbicacion = async () => {
    const { ubicacionesTab, ubicacionForm } = this.state;

    const valor = String(ubicacionForm.valor ?? "").trim();

    if (valor === "" && ubicacionesTab !== "Seccion") {
      Swal.fire({
        icon: "warning",
        title: "Dato requerido",
        text: "Debe ingresar un valor.",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const isEditing = ubicacionForm.id !== null && ubicacionForm.id !== undefined;

    const confirm = await Swal.fire({
      icon: "question",
      title: isEditing ? "¿Actualizar ubicación?" : "¿Crear ubicación?",
      html:
        "Tabla: <b>" +
        ubicacionesTab +
        "</b><br/>Valor: <b>" +
        (valor === "" ? "(Vacío)" : valor) +
        "</b>",
      showCancelButton: true,
      confirmButtonText: isEditing ? "Sí, actualizar" : "Sí, crear",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    });

    if (!confirm.isConfirmed) return;

    this.setState({ isUbicacionesLoading: true });

    try {
      const payload = isEditing
        ? {
            accion: "update",
            tabla: ubicacionesTab,
            id: ubicacionForm.id,
            valor: valor,
          }
        : {
            accion: "create",
            tabla: ubicacionesTab,
            valor: valor,
          };

      const res = await fetch(`${dominio}/UbicacionesTags`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const body = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(body?.error || "Error guardando ubicación");
      }

      await this.loadUbicacionesTags();

      this.setState({
        isUbicacionesLoading: false,
        ubicacionForm: {
          id: null,
          valor: "",
        },
      });

      Swal.fire({
        icon: "success",
        title: isEditing ? "Actualizado" : "Creado",
        text: body?.message || "Operación realizada correctamente.",
        timer: 1600,
        showConfirmButton: false,
      });
    } catch (err) {
      this.setState({ isUbicacionesLoading: false });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.message || "No se pudo guardar la ubicación.",
        confirmButtonText: "Aceptar",
      });
    }
  };

  deleteUbicacion = async (row) => {
    const { ubicacionesTab } = this.state;

    const idField = this.getUbicacionIdField(ubicacionesTab);
    const valueField = this.getUbicacionValueField(ubicacionesTab);

    const id = row[idField];
    const valor = row[valueField] || "";

    const confirm = await Swal.fire({
      icon: "warning",
      title: "¿Eliminar ubicación?",
      html:
        "Tabla: <b>" +
        ubicacionesTab +
        "</b><br/>Valor: <b>" +
        (String(valor).trim() === "" ? "(Vacío)" : valor) +
        "</b><br/><br/>Esta acción no se puede deshacer.",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      reverseButtons: true,
    });

    if (!confirm.isConfirmed) return;

    this.setState({ isUbicacionesLoading: true });

    try {
      const res = await fetch(`${dominio}/UbicacionesTags`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          accion: "delete",
          tabla: ubicacionesTab,
          id: id,
        }),
      });

      const body = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(body?.error || "Error eliminando ubicación");
      }

      await this.loadUbicacionesTags();

      this.setState({
        isUbicacionesLoading: false,
        ubicacionForm: {
          id: null,
          valor: "",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Eliminado",
        text: body?.message || "Ubicación eliminada correctamente.",
        timer: 1600,
        showConfirmButton: false,
      });
    } catch (err) {
      this.setState({ isUbicacionesLoading: false });

      Swal.fire({
        icon: "error",
        title: "Error eliminando",
        text: err?.message || "No se pudo eliminar la ubicación.",
        confirmButtonText: "Aceptar",
      });
    }
  };

  // ====== MODAL ======
  openCreateModal = () => {
    this.setState(
      (prev) => ({
        showCreateModal: true,
        isSaving: false,
        queue: [],
        editingIndex: null,
        editingExistingTag: false,
        editingExistingTagId: null,
        modalAlert: null,
        modalAlertVisible: false,
        docNumSearch: "",
        fetchedDocLines: [],
        form: {
          ItemCode: "",
          Dscription: "",
          Estante: "",
          Seccion: "",
          Nivel: "",
          Almacen: "",
          UserId: prev.currentUserId || "",
        },
      }),
      () => {
        this.loadAvailableItems();
        this.loadExistingTagsMap();
        this.loadUbicacionesTags();
        this.loadAlmacenesSAP();
      }
    );
  };

  openEditExistingTag = (rowData) => {
    if (!rowData) return;

    this.setState(
      (prev) => ({
        showCreateModal: true,
        isSaving: false,
        queue: [],
        editingIndex: null,
        editingExistingTag: true,
        editingExistingTagId: rowData?.number_tag || null,
        modalAlert: null,
        modalAlertVisible: false,
        docNumSearch: "",
        fetchedDocLines: [],
        form: {
          ItemCode: rowData?.ItemCode || "",
          Dscription: rowData?.Dscription || "",
          Estante: rowData?.Estante || "",
          Seccion: rowData?.Seccion || "",
          Nivel: rowData?.Nivel || "",
          Almacen: rowData?.Almacen || "",
          UserId: prev.currentUserId || "",
        },
      }),
      () => {
        this.loadAvailableItems();
        this.loadUbicacionesTags();
        this.loadAlmacenesSAP();
        this.setModalAlert("info", "Editando tag existente.");
      }
    );
  };

  closeCreateModal = () => {
    if (this.state.isSaving) return;
    this.clearModalAlert();
    this.setState({
      showCreateModal: false,
      editingIndex: null,
      editingExistingTag: false,
      editingExistingTagId: null,
    });
  };

  resetForm = () => {
    this.setState(
      (prev) => ({
        editingIndex: null,
        editingExistingTag: false,
        editingExistingTagId: null,
        form: {
          ItemCode: "",
          Dscription: "",
          Estante: "",
          Seccion: "",
          Nivel: "",
          Almacen: "",
          UserId: prev.currentUserId || "",
        },
      }),
      () => this.setModalAlert("info", "Formulario limpiado.")
    );
  };

  onFormChange = (field, value) => {
    this.setState((prev) => ({
      form: { ...prev.form, [field]: value },
    }));
  };

  onItemCodeChange = (value) => {
    const code = value.trim();
    this.setState((prev) => {
      const match = prev.availableItems.find((x) => x.ItemCode === code);
      return {
        form: {
          ...prev.form,
          ItemCode: value,
          Dscription: match ? xOrEmpty(match.ItemName) : prev.form.Dscription,
        },
      };
    });
  };

  // ====== Buscar DocNum y cargar a cola ======
  fetchEntradasMercanciaToQueue = async () => {
    let { docNumSearch, isSaving, isItemsLoading, currentUserId } = this.state;
    if (isSaving || isItemsLoading) return;

    const clean = String(docNumSearch || "").trim();
    if (!clean) {
      this.setModalAlert("warning", "Ingresá un DocNum para buscar.");
      return;
    }

    const docNum = Number(clean);
    if (Number.isNaN(docNum) || docNum <= 0) {
      this.setModalAlert("danger", "DocNum inválido.");
      return;
    }

    this.setState({ isItemsLoading: true });

    try {
      // Recargar siempre para reflejar tags recién creados; agrupado por ItemCode+Almacén.
      const { byItemAlm } = await this.loadExistingTagsMap();

      const url = `${dominio}/getEntradasMercanciaTags/` + docNum;
      const res = await fetch(url);
      const body = await res.json().catch(() => ({}));

      if (!res.ok || body?.answer !== "true") {
        const msg = body?.message || "No se pudo consultar DocNum " + docNum;
        throw new Error(msg);
      }

      const lines = body?.Lines || [];
      const docDate = body?.DocDate ?? null;
      if (!Array.isArray(lines) || lines.length === 0) {
        this.setState({ fetchedDocLines: [], isItemsLoading: false }, () =>
          this.setModalAlert("warning", "DocNum " + docNum + ": no trajo líneas.")
        );
        return;
      }

      const now = Date.now();
      const mapped = lines
        .map((l, idx) => {
          const itemCode = String(l.ItemCode || "")
            .trim()
            .toUpperCase();
          const itemName = String(l.ItemName || "").trim();
          if (!itemCode) return null;

          // Almacén automático desde el documento (WhsCode de SAP)
          const whs = String(l.WhsCode || "").trim();

          // El documento NO trae ubicación. Se autocompleta la ubicación SOLO si el
          // ItemCode + Almacén coincide con UN único tag existente. Si hay varios
          // (mismo código/almacén en distintas ubicaciones), es ambiguo -> queda "Nuevo"
          // con ubicación vacía para asignarla manualmente.
          const grupo = byItemAlm[itemCode + "||" + this.normalize(whs)] || [];
          const existing = grupo.length === 1 ? grupo[0] : null;

          if (existing) {
            return {
              __id: now + "-" + idx + "-" + itemCode,
              selected: false,
              copies: 1,

              ItemCode: itemCode,
              Dscription: existing.Dscription ?? itemName,
              Estante: existing.Estante ?? null,
              Seccion: existing.Seccion ?? null,
              Nivel: existing.Nivel ?? null,
              Almacen: whs || existing.Almacen || null,
              UserId: currentUserId !== "" ? Number(currentUserId) : null,

              number_tag: existing.number_tag ?? null,
              location_desc_tag:
                existing.location_desc_tag ??
                this.buildLocationDescTag(existing.Estante, existing.Seccion, existing.Nivel),
              fechaCreacion: existing.fechaCreacion ?? null,
              fechaModificacion: existing.fechaModificacion ?? null,
              docDate: docDate,

              status: "EXISTE",
              error: null,
            };
          }

          return {
            __id: now + "-" + idx + "-" + itemCode,
            selected: false,
            copies: 1,

            ItemCode: itemCode,
            Dscription: itemName,
            Estante: null,
            Seccion: null,
            Nivel: null,
            Almacen: whs || null,
            UserId: currentUserId !== "" ? Number(currentUserId) : null,

            number_tag: null,
            location_desc_tag: this.buildLocationDescTag(null, null, null),
            fechaCreacion: null,
            fechaModificacion: null,
            docDate: docDate,

            status: "NUEVO",
            error: "Varias ubicaciones en este almacén: asignar ubicación.",
          };
        })
        .filter(Boolean);

      this.setState(
        (prev) => {
          const merged = [...(prev.queue || []), ...mapped];
          const flagged = this.recomputeDuplicates(merged);
          return { queue: flagged, fetchedDocLines: lines, isItemsLoading: false };
        },
        () =>
          this.setModalAlert(
            "success",
            "DocNum " +
              docNum +
              ": líneas cargadas. Los repetidos exactos en cola se permitirán, pero al crear solo se registrará una combinación igual."
          )
      );
    } catch (err) {
      this.setState({ isItemsLoading: false }, () =>
        this.setModalAlert("danger", err?.message || "Error consultando DocNum.")
      );
    }
  };

  clearDocSearch = () => {
    this.setState({ docNumSearch: "", fetchedDocLines: [] }, () => this.setModalAlert("info", "DocNum limpiado."));
  };

  // ====== VALIDACIÓN ======
  validateFormForQueue = () => {
    const { form, editingIndex, queue, currentUserId } = this.state;

    const itemCode = this.normalize(form.ItemCode);
    const desc = String(form.Dscription || "").trim();
    if (!itemCode || !desc) return "ItemCode y Descripción son obligatorios.";

    const candidate = {
      ItemCode: itemCode,
      Estante: form.Estante?.trim() || null,
      Seccion: form.Seccion?.trim() || null,
      Nivel: form.Nivel !== "" ? String(form.Nivel).trim() : null,
      Almacen: form.Almacen?.trim() || null,
    };
    const candKey = this.comboKey(candidate);

    const dupIndex = (queue || []).findIndex((q, idx) => this.comboKey(q) === candKey && idx !== editingIndex);
    if (dupIndex !== -1) {
      return "No se permite repetir manualmente la combinación ItemCode + Estante + Sección + Nivel + Almacén.";
    }

    if (currentUserId !== "" && currentUserId !== null && currentUserId !== undefined) {
      const n = Number(currentUserId);
      if (Number.isNaN(n)) return "El UserId del token no es válido.";
    }

    return null;
  };

  addOrUpdateQueue = () => {
    const error = this.validateFormForQueue();
    if (error) {
      this.setModalAlert("danger", error);
      return;
    }

    const { form, editingIndex, currentUserId } = this.state;

    const estante = form.Estante?.trim() || "";
    const seccion = form.Seccion?.trim() || "";
    const nivel = form.Nivel !== "" ? String(form.Nivel).trim() : "";
    const almacen = form.Almacen?.trim() || "";
    const location_desc_tag = this.buildLocationDescTag(estante, seccion, nivel);

    const item = {
      __id: editingIndex !== null ? this.state.queue?.[editingIndex]?.__id : Date.now() + "-" + Math.random(),
      selected: false,
      copies: 1,

      ItemCode: this.normalize(form.ItemCode),
      Dscription: String(form.Dscription || "").trim(),
      Estante: estante || null,
      Seccion: seccion || null,
      Nivel: nivel || null,
      Almacen: almacen || null,
      UserId: currentUserId !== "" ? Number(currentUserId) : null,

      status: "NUEVO",
      error: null,

      number_tag: null,
      location_desc_tag: location_desc_tag,
      fechaCreacion: null,
      fechaModificacion: null,
    };

    // Si esta combinación (ItemCode + Estante + Sección + Nivel + Almacén) YA existe
    // en la base, marcarla como "Ya creado" para no intentar recrearla ni mostrar el
    // falso "duplicado". La unicidad respeta el almacén: mismo ítem/ubicación en otro
    // almacén NO se considera existente.
    const yaCreado = this.state.existingTagsMap
      ? this.state.existingTagsMap[this.comboKey(item)]
      : null;
    if (yaCreado) {
      item.status = "EXISTE";
      item.number_tag = yaCreado.number_tag ?? null;
      item.location_desc_tag = yaCreado.location_desc_tag ?? location_desc_tag;
      item.fechaCreacion = yaCreado.fechaCreacion ?? null;
      item.fechaModificacion = yaCreado.fechaModificacion ?? null;
    }

    this.setState(
      (prev) => {
        const newQueue = [...(prev.queue || [])];
        if (editingIndex !== null) {
          const prevRow = newQueue[editingIndex] || {};
          newQueue[editingIndex] = {
            ...prevRow,
            ...item,
            selected: prevRow.selected ?? false,
            copies: prevRow.copies ?? 1,
          };
        } else {
          newQueue.push(item);
        }

        const flagged = this.recomputeDuplicates(newQueue);

        return {
          queue: flagged,
          editingIndex: null,
          form: {
            ItemCode: "",
            Dscription: "",
            Estante: "",
            Seccion: "",
            Nivel: "",
            Almacen: "",
            UserId: prev.currentUserId || "",
          },
        };
      },
      () =>
        this.setModalAlert(
          item.status === "EXISTE" ? "info" : editingIndex !== null ? "warning" : "success",
          item.status === "EXISTE"
            ? 'Esa combinación ya existe (Tag ' + (item.number_tag || "") + '): se marcó como "Ya creado".'
            : editingIndex !== null
            ? "Elemento actualizado en la cola."
            : "Añadido a la cola."
        )
    );
  };

  updateExistingTag = async () => {
    const { form, editingExistingTagId, currentUserId } = this.state;

    const itemCode = this.normalize(form.ItemCode);
    const desc = String(form.Dscription || "").trim();

    if (!editingExistingTagId) {
      this.setModalAlert("danger", "No se encontró el number_tag a editar.");
      return;
    }

    if (!itemCode || !desc) {
      this.setModalAlert("danger", "ItemCode y Descripción son obligatorios.");
      return;
    }

    if (currentUserId !== "" && currentUserId !== null && currentUserId !== undefined) {
      const n = Number(currentUserId);
      if (Number.isNaN(n)) {
        this.setModalAlert("danger", "El UserId del token no es válido.");
        return;
      }
    }

    const estante = form.Estante?.trim() || "";
    const seccion = form.Seccion?.trim() || "";
    const nivel = form.Nivel !== "" ? String(form.Nivel).trim() : "";
    const almacen = form.Almacen?.trim() || "";
    const location_desc_tag = this.buildLocationDescTag(estante, seccion, nivel);

    const payload = {
      number_tag: String(editingExistingTagId).trim(),
      ItemCode: itemCode,
      Dscription: desc,
      Estante: estante || null,
      Seccion: seccion || null,
      Nivel: nivel || null,
      Almacen: almacen || null,
      UserId: currentUserId !== "" ? Number(currentUserId) : null,
      location_desc_tag: location_desc_tag,
    };

    this.setState({ isSaving: true }, () => this.setModalAlert("info", "Actualizando tag..."));

    try {
      const res = await fetch(`${dominio}/patchTags`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const body = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(body?.error || body?.detail || "HTTP " + res.status);
      }

      await this.loadData();
      await this.loadExistingTagsMap();

      this.setState(
        (prev) => ({
          isSaving: false,
          showCreateModal: false,
          editingExistingTag: false,
          editingExistingTagId: null,
          editingIndex: null,
          form: {
            ItemCode: "",
            Dscription: "",
            Estante: "",
            Seccion: "",
            Nivel: "",
            Almacen: "",
            UserId: prev.currentUserId || "",
          },
        }),
        () => this.setModalAlert("success", "Tag actualizado correctamente.")
      );
    } catch (err) {
      this.setState({ isSaving: false }, () =>
        this.setModalAlert("danger", "Error actualizando tag: " + (err?.message || "Error"))
      );
    }
  };

  // ====== DELETE: eliminar tag existente por number_tag ======
  deleteExistingTag = async (rowData) => {
    const numberTag = rowData?.number_tag;

    if (!numberTag || String(numberTag).trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Tag inválido",
        text: "La fila seleccionada no tiene number_tag para eliminar.",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    const result = await Swal.fire({
      icon: "warning",
      title: "¿Eliminar tag?",
      html:
        "Se eliminará el tag <b>" +
        String(numberTag) +
        "</b><br/>" +
        "Artículo: <b>" +
        String(rowData?.ItemCode || "") +
        "</b><br/><br/>" +
        "Esta acción no se puede deshacer.",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    this.setState({ isLoading: true, message: "" });

    try {
      const res = await fetch(`${dominio}/deleteTags`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          number_tag: String(numberTag).trim(),
        }),
      });

      const body = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(body?.error || body?.detail || "HTTP " + res.status);
      }

      await this.loadData();
      await this.loadExistingTagsMap();

      Swal.fire({
        icon: "success",
        title: "Eliminado",
        text: body?.message || "TAG eliminado correctamente.",
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (err) {
      this.setState({
        isLoading: false,
        message: "Error eliminando tag: " + (err?.message || "Error"),
      });

      Swal.fire({
        icon: "error",
        title: "Error eliminando tag",
        text: err?.message || "No se pudo eliminar el tag.",
        confirmButtonText: "Aceptar",
      });
    }
  };

  editQueueItem = (index) => {
    const { queue, currentUserId } = this.state;
    const q = queue[index];
    if (!q) return;

    this.setState(
      {
        editingIndex: index,
        editingExistingTag: false,
        editingExistingTagId: null,
        form: {
          ItemCode: q.ItemCode || "",
          Dscription: q.Dscription || "",
          Estante: q.Estante || "",
          Seccion: q.Seccion || "",
          Nivel: q.Nivel || "",
          Almacen: q.Almacen || "",
          UserId: currentUserId || "",
        },
      },
      () => this.setModalAlert("info", "Editando elemento de la cola.")
    );
  };

  removeQueueItem = (index) => {
    this.setState(
      (prev) => {
        const newQueue = (prev.queue || []).filter((_, i) => i !== index);
        const flagged = this.recomputeDuplicates(newQueue);

        const wasEditing = prev.editingIndex === index;
        const newEditingIndex =
          prev.editingIndex === null
            ? null
            : prev.editingIndex > index
            ? prev.editingIndex - 1
            : prev.editingIndex;

        return {
          queue: flagged,
          editingIndex: wasEditing ? null : newEditingIndex,
          form: wasEditing
            ? {
                ItemCode: "",
                Dscription: "",
                Estante: "",
                Seccion: "",
                Nivel: "",
                Almacen: "",
                UserId: prev.currentUserId || "",
              }
            : prev.form,
        };
      },
      () => this.setModalAlert("danger", "Elemento eliminado de la cola.")
    );
  };

  // =========================
  // POST: crear 1 tag
  // =========================
  postOneTag = async (payload) => {
    const res = await fetch(`${dominio}/postTags`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
      const detail = body?.error || body?.detail || "HTTP " + res.status;
      throw new Error(detail);
    }

    return body;
  };

  // =========================
  // CREAR TODOS
  // =========================
  createAllFromQueue = async () => {
    const { queue } = this.state;

    if (!queue || queue.length === 0) {
      this.setModalAlert("warning", "La cola está vacía.");
      return;
    }

    const onlyNew = (queue || []).filter((q) => q.status === "NUEVO");
    if (!onlyNew || onlyNew.length === 0) {
      this.setModalAlert("warning", "No hay elementos NUEVOS para crear.");
      return;
    }

    const toCreate = this.getUniqueQueueRowsByCombo(onlyNew);

    this.setState({ isSaving: true }, () => this.setModalAlert("info", "Creando tags..."));

    const resultsByKey = new Map();
    let ok = 0;
    let fail = 0;

    for (let i = 0; i < toCreate.length; i++) {
      const q = toCreate[i];
      const key = this.comboKey(q);

      try {
        const body = await this.postOneTag(q);
        const data = body?.data?.data || body?.data || {};
        resultsByKey.set(key, { ok: true, data });
        ok++;
      } catch (err) {
        resultsByKey.set(key, { ok: false, error: err?.message || "Error" });
        fail++;
      }
    }

    await this.loadData();
    await this.loadExistingTagsMap();

    this.setState(
      (prev) => {
        const updated = (prev.queue || []).map((q) => {
          if (q.status !== "NUEVO") return q;

          const key = this.comboKey(q);
          const r = resultsByKey.get(key);
          if (!r) return q;

          if (r.ok) {
            const d = r.data || {};
            return {
              ...q,
              status: "EXISTE",
              error: null,

              selected: q.selected ?? false,
              copies: q.copies ?? 1,

              number_tag: d.number_tag ?? q.number_tag,
              location_desc_tag:
                d.location_desc_tag ??
                this.buildLocationDescTag(d.Estante ?? q.Estante, d.Seccion ?? q.Seccion, d.Nivel ?? q.Nivel),
              fechaCreacion: d.fechaCreacion ?? q.fechaCreacion,
              fechaModificacion: d.fechaModificacion ?? q.fechaModificacion,

              Estante: d.Estante ?? q.Estante,
              Seccion: d.Seccion ?? q.Seccion,
              Nivel: d.Nivel ?? q.Nivel,
              Almacen: d.Almacen ?? q.Almacen,
              UserId: d.UserId ?? q.UserId,
            };
          }

          return { ...q, status: "ERROR", error: r.error || "Error" };
        });

        const flagged = this.recomputeDuplicates(updated);
        return { queue: flagged, isSaving: false, editingIndex: null };
      },
      () =>
        this.setModalAlert(
          fail > 0 ? "warning" : "success",
          "Proceso terminado. Combinaciones creadas: " + ok + ", Error: " + fail + "."
        )
    );
  };

  // ====== impresión (grid principal) ======
  printTag = (numberTag, itemCode, description, location, almacen) => {
    if (!numberTag) {
      this.setState({ message: "La fila seleccionada no tiene Tag para imprimir." });
      return;
    }

    const w = window.open("", "_blank", "width=500,height=600");
    if (!w) {
      this.setState({ message: "El navegador bloqueó el popup de impresión. Permití popups para este sitio." });
      return;
    }

    w.document.write(`
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Imprimir Tag</title>
          <style>
            @page { size: 29.9mm 18mm; margin: 0; }

            html, body {
              width: 29.9mm;
              height: 18mm;
              margin: 0;
              padding: 0;
              overflow: hidden;
              background: #fff;
            }

            body {
              font-family: Tahoma, Verdana, Segoe UI, Arial, sans-serif;
            }

            .label {
              width: 29.9mm;
              height: 18mm;
              margin: 0;
              padding: 0.15mm 0.35mm 0.15mm 0.35mm;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              text-align: center;
              overflow: hidden;
            }

            .barcode-wrap {
              width: 100%;
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: flex-start;
            }

            svg {
              width: 28.9mm;
              height: 6.4mm;
              display: block;
              margin: 0;
              padding: 0;
            }

            .line {
              width: 100%;
              margin: 0;
              padding: 0;
              text-align: center;
              overflow: hidden;
            }

            .line-tag {
              font-size: 8pt;
              line-height: 0.98;
              font-weight: 700;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-top: -0.15mm;
              margin-bottom: 0.25mm;
            }

            .line-desc {
              font-size: 6.5pt;
              line-height: 0.98;
              font-weight: 400;
              white-space: normal;
              word-break: break-word;
              overflow: hidden;
              text-overflow: clip;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              min-height: 4.5mm;
              max-height: 4.5mm;
              margin-bottom: 0.25mm;
            }

            .line-loc {
              font-size: 6.9pt;
              line-height: 0.98;
              font-weight: 700;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-top: 0.15mm;
            }

            .toolbar {
              display: flex;
              gap: 8px;
              justify-content: center;
              margin-top: 8px;
            }

            @media print {
              .toolbar { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="label">
            <div class="barcode-wrap">
              <svg id="barcode"></svg>
            </div>

            <div class="line line-tag">${String(itemCode || "")}</div>
            <div class="line line-desc" id="descText">${String(description || "")}</div>
            <div class="line line-loc">${String(location || "")}${almacen ? "   " + String(almacen) : ""}</div>
          </div>

          <div class="toolbar">
            <button id="btnPrint">Imprimir</button>
          </div>

          <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>
          <script>
            try {
              JsBarcode("#barcode", ${JSON.stringify(String(numberTag || ""))}, {
                format: "CODE128",
                displayValue: false,
                margin: 0,
                marginTop: 0,
                marginBottom: 0,
                height: 24,
                width: 1
              });
            } catch (e) {
              document.body.innerHTML = "<p>Error generando código de barras: " + e.message + "</p>";
            }

            function waitForRender() {
              return new Promise(resolve => {
                requestAnimationFrame(() => requestAnimationFrame(resolve));
              });
            }

            function fitDescription() {
              const desc = document.getElementById("descText");
              if (!desc) return;

              let fontSize = 6.5;
              desc.style.fontSize = fontSize + "pt";

              while (fontSize > 4.8 && desc.scrollHeight > desc.clientHeight) {
                fontSize -= 0.2;
                desc.style.fontSize = fontSize + "pt";
              }
            }

            fitDescription();

            const btn = document.getElementById("btnPrint");
            btn.addEventListener("click", async () => {
              btn.disabled = true;
              try {
                window.focus();
                await waitForRender();
                setTimeout(() => window.print(), 120);
              } finally {
                setTimeout(() => { btn.disabled = false; }, 1200);
              }
            });
          </script>
        </body>
      </html>
    `);

    w.document.close();
    w.focus();
  };

  // ====== GRID principal ======
  renderGrid() {
    const { dataAdapter } = this.state;
    if (!dataAdapter) return null;

    return (
      <div className="tags-grid-shell">
        <JqxGrid
          theme="ui-redmond"
          ref={this.gridRef}
          width={"100%"}
          autoheight={false}
          height={560}
          source={dataAdapter}
          editable={false}
          enablebrowserselection={true}
          columnsresize={true}
          pageable={true}
          pagesize={25}
          sortable={true}
          filterable={true}
          showfilterrow={true}
          altrows={true}
          selectionmode={"singlerow"}
          columnsheight={42}
          rowsheight={36}
          columns={[
            {
              text: "Imprimir",
              datafield: "print_tag",
              columntype: "button",
              width: "7%",
              cellsrenderer: () => "🖨️ Imprimir",
              buttonclick: (row) => {
                const rowData = this.gridRef.current.getrowdata(row);
                const numberTag = rowData?.number_tag;
                const itemCode = rowData?.ItemCode;
                const description = rowData?.Dscription;
                const location = rowData?.location_desc_tag;
                const almacen = rowData?.Almacen;
                this.printTag(numberTag, itemCode, description, location, almacen);
              },
            },
            {
              text: "Editar",
              datafield: "edit_tag",
              columntype: "button",
              width: "7%",
              cellsrenderer: () => "✏️ Editar",
              buttonclick: (row) => {
                const rowData = this.gridRef.current.getrowdata(row);
                this.openEditExistingTag(rowData);
              },
            },
            {
              text: "Eliminar",
              datafield: "delete_tag",
              columntype: "button",
              width: "7%",
              cellsrenderer: () => "🗑️ Eliminar",
              buttonclick: (row) => {
                const rowData = this.gridRef.current.getrowdata(row);
                this.deleteExistingTag(rowData);
              },
            },

            { text: "ItemCode", datafield: "ItemCode", width: "8%" },
            { text: "Descripción", datafield: "Dscription", width: "25%" },
            { text: "Tag", datafield: "number_tag", width: "8%" },
            { text: "Ubicación", datafield: "location_desc_tag", width: "10%" },
            { text: "Creación", datafield: "fechaCreacion", width: "8%", cellsformat: "yyyy-MM-dd HH:mm" },
            { text: "Modificación", datafield: "fechaModificacion", width: "8%", cellsformat: "yyyy-MM-dd HH:mm" },
            { text: "Estante", datafield: "Estante", width: "5%" },
            { text: "Sección", datafield: "Seccion", width: "5%" },
            { text: "Nivel", datafield: "Nivel", width: "5%" },
            { text: "Almacén", datafield: "Almacen", width: "6%" },
          ]}
        />
      </div>
    );
  }

  downloadExcel = async () => {
    this.setState({ message: "" });

    try {
      const res = await fetch(`${dominio}/getTags`);
      if (!res.ok) throw new Error("HTTP " + res.status);

      const data = await res.json();
      const rows = Array.isArray(data) ? data : [];

      if (rows.length === 0) {
        this.setState({ message: "No hay datos para exportar." });
        return;
      }

      const exportData = rows.map((row) => ({
        ItemCode: row.ItemCode || "",
        Dscription: row.Dscription || "",
        number_tag: row.number_tag || "",
        location_desc_tag: row.location_desc_tag || "",
        fechaCreacion: row.fechaCreacion ? new Date(row.fechaCreacion).toLocaleString("es-GT") : "",
        fechaModificacion: row.fechaModificacion ? new Date(row.fechaModificacion).toLocaleString("es-GT") : "",
        Estante: row.Estante || "",
        Seccion: row.Seccion || "",
        Nivel: row.Nivel || "",
        Almacen: row.Almacen || "",
        UserId: row.UserId ?? "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);

      const columnWidths = [
        { wch: 18 },
        { wch: 40 },
        { wch: 18 },
        { wch: 22 },
        { wch: 22 },
        { wch: 22 },
        { wch: 12 },
        { wch: 12 },
        { wch: 10 },
        { wch: 14 },
        { wch: 10 },
      ];
      worksheet["!cols"] = columnWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Tags");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const today = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      const fileName =
        "Tags_" +
        today.getFullYear() +
        "-" +
        pad(today.getMonth() + 1) +
        "-" +
        pad(today.getDate()) +
        "_" +
        pad(today.getHours()) +
        "-" +
        pad(today.getMinutes()) +
        ".xlsx";

      saveAs(blob, fileName);
      this.setState({ message: "Excel descargado correctamente." });
    } catch (err) {
      this.setState({
        message: "Error descargando Excel: " + (err?.message || "Error"),
      });
    }
  };

  // ====== SELECTOR DE UBICACIÓN (elegir entre ubicaciones existentes) ======
  // Devuelve los tags existentes para el ItemCode + Almacén de una fila de la cola.
  getOpcionesUbicacion = (q) => {
    if (!q) return [];
    const key = this.normalize(q.ItemCode) + "||" + this.normalize(q.Almacen);
    return this.state.tagsByItemAlmacen[key] || [];
  };

  openUbicacionPicker = (index) => {
    const q = this.state.queue?.[index];
    if (!q) return;
    const opciones = this.getOpcionesUbicacion(q);
    if (opciones.length === 0) {
      this.setModalAlert("info", "No hay ubicaciones registradas para este código en este almacén.");
      return;
    }
    this.setState({ showUbicacionPicker: true, pickerIndex: index, pickerOptions: opciones });
  };

  closeUbicacionPicker = () => {
    this.setState({ showUbicacionPicker: false, pickerIndex: null, pickerOptions: [] });
  };

  selectUbicacionFromPicker = (tag) => {
    this.setState(
      (prev) => {
        const idx = prev.pickerIndex;
        const q = [...(prev.queue || [])];
        if (idx === null || idx === undefined || !q[idx]) {
          return { showUbicacionPicker: false, pickerIndex: null, pickerOptions: [] };
        }
        q[idx] = {
          ...q[idx],
          Estante: tag.Estante ?? null,
          Seccion: tag.Seccion ?? null,
          Nivel: tag.Nivel ?? null,
          Almacen: tag.Almacen ?? q[idx].Almacen,
          location_desc_tag:
            tag.location_desc_tag ??
            this.buildLocationDescTag(tag.Estante, tag.Seccion, tag.Nivel),
          number_tag: tag.number_tag ?? null,
          fechaCreacion: tag.fechaCreacion ?? q[idx].fechaCreacion,
          fechaModificacion: tag.fechaModificacion ?? q[idx].fechaModificacion,
          status: "EXISTE",
          error: null,
        };
        const flagged = this.recomputeDuplicates(q);
        return { queue: flagged, showUbicacionPicker: false, pickerIndex: null, pickerOptions: [] };
      },
      () => this.setModalAlert("success", "Ubicación seleccionada (tag existente).")
    );
  };

  // ====== TABLA COLA ======
  renderQueueTable() {
    const { queue, editingIndex, isSaving } = this.state;

    if (!queue || queue.length === 0) {
      return <div className="queue-empty-state">No hay elementos en la cola.</div>;
    }

    const total = queue.length;
    const selectedCount = queue.filter((q) => q.selected).length;
    const allSelected = total > 0 && selectedCount === total;

    return (
      <div className="queue-table-wrap">
        <Table condensed hover className="queue-table" style={{ marginBottom: 0 }}>
          <thead>
            <tr>
              <th style={{ width: 30, textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) => this.toggleSelectAllQueue(e.target.checked)}
                  disabled={isSaving}
                  title="Seleccionar todos"
                />
              </th>
              <th> </th>
              <th> </th>
              <th>#</th>
              <th>Estado</th>
              <th>ItemCode</th>
              <th>Descripción</th>
              <th>Tag</th>
              <th>Ubicación</th>
              <th>Estante</th>
              <th>Sección</th>
              <th>Nivel</th>
              <th>Almacén</th>
              <th>UserId</th>
              <th>Copias</th>
              <th>Dup</th>
              <th>Error</th>
            </tr>
          </thead>

          <tbody>
            {queue.map((q, idx) => (
              <tr
                key={q.__id || q.ItemCode + "-" + idx}
                className={[
                  idx === editingIndex ? "row-editing" : "",
                  q.isDup ? "row-dup" : "",
                  q.status === "EXISTE" ? "row-existe" : "",
                  q.status === "NUEVO" ? "row-nuevo" : "",
                  q.status === "ERROR" ? "row-error" : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                <td style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={!!q.selected}
                    onChange={(e) => this.toggleQueueSelect(idx, e.target.checked)}
                    disabled={isSaving}
                    title="Seleccionar para imprimir"
                  />
                </td>

                <td>
                  <Button
                    bsStyle="warning"
                    bsSize="xsmall"
                    onClick={() => this.editQueueItem(idx)}
                    disabled={isSaving}
                    style={{ marginRight: 6 }}
                  >
                    Editar
                  </Button>
                </td>

                <td>
                  <Button bsStyle="danger" bsSize="xsmall" onClick={() => this.removeQueueItem(idx)} disabled={isSaving}>
                    Eliminar
                  </Button>
                </td>

                <td>{idx + 1}</td>
                <td>
                  {q.status === "EXISTE"
                    ? "Ya creado"
                    : q.status === "NUEVO"
                    ? "Nuevo"
                    : q.status === "ERROR"
                    ? "Error"
                    : ""}
                </td>
                <td>{q.ItemCode}</td>
                <td>{q.Dscription}</td>
                <td>{q.number_tag ?? ""}</td>
                <td style={{ minWidth: 140 }}>
                  {q.location_desc_tag ?? ""}
                  {q.status !== "EXISTE" && this.getOpcionesUbicacion(q).length > 0 && (
                    <div>
                      <Button
                        bsStyle="info"
                        bsSize="xsmall"
                        onClick={() => this.openUbicacionPicker(idx)}
                        disabled={isSaving}
                        style={{ marginTop: 3 }}
                        title="Elegir entre las ubicaciones ya existentes de este código en este almacén"
                      >
                        Elegir ubicación
                      </Button>
                    </div>
                  )}
                </td>
                <td>{q.Estante || ""}</td>
                <td>{q.Seccion || ""}</td>
                <td>{q.Nivel || ""}</td>
                <td>{q.Almacen || ""}</td>
                <td>{q.UserId ?? ""}</td>

                <td style={{ width: 60 }}>
                  <input
                    type="number"
                    min="1"
                    step="1"
                    value={q.copies ?? 1}
                    disabled={isSaving}
                    onChange={(e) => this.setQueueCopies(idx, e.target.value)}
                    style={{ width: 45 }}
                    title="Copias por tag (mínimo 1)"
                  />
                </td>

                <td>{q.isDup ? "DUP" : ""}</td>
                <td
                  style={{ minWidth: 150, maxWidth: 220, whiteSpace: "normal", wordBreak: "break-word", lineHeight: 1.2 }}
                  title={q.error || ""}
                >
                  {q.error ?? ""}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="queue-footer-bar">
          <div className="queue-footer-text">
            Seleccionados: <b>{selectedCount}</b> / {total} — (Imprime solo seleccionados con Tag)
          </div>

          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <Button bsStyle="default" bsSize="xsmall" onClick={() => this.toggleSelectAllQueue(false)} disabled={isSaving}>
              Quitar selección
            </Button>

            <Button
              bsStyle="primary"
              bsSize="xsmall"
              onClick={this.printSelectedFromQueueSingleWindow}
              disabled={isSaving || selectedCount === 0}
              title="Imprime en una sola ventana"
            >
              Imprimir seleccionados (1 ventana)
            </Button>
          </div>
        </div>
      </div>
    );
  }

  renderCreateModal() {
    const {
      showCreateModal,
      form,
      isSaving,
      isItemsLoading,
      availableItems,
      queue,
      editingIndex,
      editingExistingTag,
      modalAlert,
      modalAlertVisible,
      docNumSearch,
      ubicaciones,
      isUbicacionesLoading,
      almacenesSAP,
    } = this.state;

    const isEditing = editingIndex !== null;

    return (
      <Modal
        show={showCreateModal}
        onHide={this.closeCreateModal}
        backdrop={isSaving ? "static" : true}
        dialogClassName="modal-wide-tags"
      >
        <Modal.Header closeButton={!isSaving} className="tags-modal-header">
          <Modal.Title className="tags-modal-title-center">{editingExistingTag ? "Editar Tag" : "Crear Tags"}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="tags-modal-body">
          <div className={"alert-slide " + (modalAlert && modalAlertVisible ? "show" : "")}>
            {modalAlert && (
              <Alert bsStyle={modalAlert.type} onDismiss={this.clearModalAlert} style={{ marginBottom: 0, textAlign: "left" }}>
                {modalAlert.text}
              </Alert>
            )}
          </div>

          <div className="tags-modal-toolbar">
            <Button onClick={this.resetForm} disabled={isSaving}>
              Limpiar
            </Button>
          </div>

          {!editingExistingTag && (
            <>
              <hr className="tags-divider" />
              <div className="tags-docnum-row">
                <FormGroup style={{ flex: 1, marginBottom: 0 }}>
                  <ControlLabel># Documento (Entrada de Mercancía)</ControlLabel>
                  <FormControl
                    type="number"
                    value={docNumSearch}
                    onChange={(e) => this.setState({ docNumSearch: e.target.value })}
                    disabled={isSaving || isItemsLoading}
                    placeholder="Ej: 70003990"
                  />
                </FormGroup>

                <Button
                  bsStyle="primary"
                  onClick={this.fetchEntradasMercanciaToQueue}
                  disabled={isSaving || isItemsLoading}
                  style={{ height: 34 }}
                >
                  {isItemsLoading ? "Buscando..." : "Buscar y cargar a cola"}
                </Button>

                <Button onClick={this.clearDocSearch} disabled={isSaving || isItemsLoading} style={{ height: 34 }}>
                  Limpiar
                </Button>
              </div>
            </>
          )}

          <div className="tags-form-card">
            <FormGroup>
              <ControlLabel>Codigo *</ControlLabel>
              <FormControl
                type="text"
                value={form.ItemCode}
                onChange={(e) => this.onItemCodeChange(e.target.value)}
                disabled={isSaving || isItemsLoading}
                placeholder={isItemsLoading ? "Cargando items..." : "Escribí o seleccioná ItemCode"}
                list="itemcodes"
              />
              <datalist id="itemcodes">
                {availableItems.map((it) => (
                  <option key={it.ItemCode} value={it.ItemCode}>
                    {it.ItemName}
                  </option>
                ))}
              </datalist>
            </FormGroup>

            <FormGroup>
              <ControlLabel>Descripción *</ControlLabel>
              <FormControl type="text" value={form.Dscription} disabled={true} placeholder="Se llena automáticamente" />
            </FormGroup>

            <Row>
              <Col md={4}>
                <FormGroup>
                  <ControlLabel>Estante (Ubicación)</ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={form.Estante || ""}
                    onChange={(e) => this.onFormChange("Estante", e.target.value)}
                    disabled={isSaving || isUbicacionesLoading}
                  >
                    <option value="">-- Seleccionar --</option>
                    {(ubicaciones.Estante || []).map((x) => (
                      <option key={x.idEstante} value={x.Estante || ""}>
                        {x.Estante || "(Vacío)"}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <ControlLabel>Sección</ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={form.Seccion || ""}
                    onChange={(e) => this.onFormChange("Seccion", e.target.value)}
                    disabled={isSaving || isUbicacionesLoading}
                  >
                    <option value="">(Vacío)</option>
                    {(ubicaciones.Seccion || [])
                      .filter((x) => String(x.Seccion || "") !== "")
                      .map((x) => (
                        <option key={x.idSeccion} value={x.Seccion || ""}>
                          {x.Seccion || "(Vacío)"}
                        </option>
                      ))}
                  </FormControl>
                </FormGroup>
              </Col>

              <Col md={4}>
                <FormGroup>
                  <ControlLabel>Nivel</ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={form.Nivel || ""}
                    onChange={(e) => this.onFormChange("Nivel", e.target.value)}
                    disabled={isSaving || isUbicacionesLoading}
                  >
                    <option value="">-- Seleccionar --</option>
                    {(ubicaciones.Nivel || []).map((x) => (
                      <option key={x.idNivel} value={x.Nivel || ""}>
                        {x.Nivel || "(Vacío)"}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <FormGroup>
                  <ControlLabel>Almacén</ControlLabel>
                  <FormControl
                    componentClass="select"
                    value={form.Almacen || ""}
                    onChange={(e) => this.onFormChange("Almacen", e.target.value)}
                    disabled={isSaving || isUbicacionesLoading}
                  >
                    <option value="">-- Seleccionar --</option>
                    {form.Almacen &&
                      !(almacenesSAP || []).some((x) => (x.WhsCode || "") === form.Almacen) && (
                        <option value={form.Almacen}>{form.Almacen}</option>
                      )}
                    {(almacenesSAP || []).map((x) => (
                      <option key={x.WhsCode} value={x.WhsCode}>
                        {x.WhsCode}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
          </div>

          <div className="tags-action-row">
            <Button
              bsStyle={editingExistingTag ? "warning" : isEditing ? "warning" : "info"}
              onClick={editingExistingTag ? this.updateExistingTag : this.addOrUpdateQueue}
              disabled={isSaving || isItemsLoading}
            >
              {editingExistingTag ? "Actualizar tag" : isEditing ? "Actualizar en cola" : "Añadir a la cola"}
            </Button>
          </div>

          {!editingExistingTag && (
            <>
              <hr className="tags-divider" />

              <div className="queue-header-bar">
                <strong>Cola ({queue.length}) — Verde=Ya creado / Amarillo=Nuevo / Rojo=Duplicado / Azul=Duplicado ya creado / Gris=Error</strong>
                <Button bsStyle="primary" onClick={this.createAllFromQueue} disabled={isSaving || queue.length === 0 || isItemsLoading}>
                  {isSaving ? "Creando..." : "Crear todos (solo nuevos)"}
                </Button>
              </div>

              {this.renderQueueTable()}
            </>
          )}
        </Modal.Body>

        <Modal.Footer className="tags-modal-footer">
          <Button onClick={this.closeCreateModal} disabled={isSaving}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }


  renderUbicacionesModal() {
    const {
      showUbicacionesModal,
      ubicacionesTab,
      ubicaciones,
      ubicacionForm,
      isUbicacionesLoading,
    } = this.state;

    const rows = ubicaciones[ubicacionesTab] || [];
    const idField = this.getUbicacionIdField(ubicacionesTab);
    const valueField = this.getUbicacionValueField(ubicacionesTab);

    return (
      <Modal
        show={showUbicacionesModal}
        onHide={this.closeUbicacionesModal}
        backdrop={isUbicacionesLoading ? "static" : true}
        dialogClassName="modal-wide-tags"
      >
        <Modal.Header closeButton={!isUbicacionesLoading} className="tags-modal-header">
          <Modal.Title className="tags-modal-title-center">Administrar Ubicaciones</Modal.Title>
        </Modal.Header>

        <Modal.Body className="tags-modal-body" style={{ maxHeight: "72vh", overflowY: "auto" }}>
          <div className="tags-modal-toolbar" style={{ justifyContent: "flex-start", marginBottom: 15 }}>
            <Button
              bsStyle={ubicacionesTab === "Estante" ? "primary" : "default"}
              onClick={() => this.changeUbicacionesTab("Estante")}
              disabled={isUbicacionesLoading}
            >
              Estante
            </Button>

            <Button
              bsStyle={ubicacionesTab === "Seccion" ? "primary" : "default"}
              onClick={() => this.changeUbicacionesTab("Seccion")}
              disabled={isUbicacionesLoading}
            >
              Sección
            </Button>

            <Button
              bsStyle={ubicacionesTab === "Nivel" ? "primary" : "default"}
              onClick={() => this.changeUbicacionesTab("Nivel")}
              disabled={isUbicacionesLoading}
            >
              Nivel
            </Button>
          </div>

          <hr className="tags-divider" />

          <div className="tags-form-card">
            <FormGroup>
              <ControlLabel>
                {ubicacionForm.id ? "Editar " + ubicacionesTab : "Nuevo " + ubicacionesTab}
              </ControlLabel>

              <FormControl
                type="text"
                value={ubicacionForm.valor}
                onChange={(e) =>
                  this.setState({
                    ubicacionForm: {
                      ...this.state.ubicacionForm,
                      valor: e.target.value,
                    },
                  })
                }
                disabled={isUbicacionesLoading}
                placeholder={"Ingrese " + ubicacionesTab}
              />
            </FormGroup>

            <div className="tags-action-row" style={{ justifyContent: "flex-start", marginTop: 10 }}>
              <Button
                bsStyle={ubicacionForm.id ? "warning" : "success"}
                onClick={this.saveUbicacion}
                disabled={isUbicacionesLoading}
              >
                {ubicacionForm.id ? "Actualizar" : "Crear"}
              </Button>

              <Button onClick={this.clearUbicacionForm} disabled={isUbicacionesLoading}>
                Limpiar
              </Button>
            </div>
          </div>

          <hr className="tags-divider" />

          <div className="queue-header-bar">
            <strong>
              {ubicacionesTab} ({rows.length})
            </strong>

            <Button bsStyle="primary" onClick={() => this.loadUbicacionesTags()} disabled={isUbicacionesLoading}>
              {isUbicacionesLoading ? "Cargando..." : "Recargar"}
            </Button>
          </div>

          <div className="queue-table-wrap" style={{ maxHeight: 360, overflowY: "auto" }}>
            <Table condensed hover bordered className="queue-table" style={{ marginBottom: 0 }}>
              <thead>
                <tr>
                  <th style={{ width: 80 }}>ID</th>
                  <th>{ubicacionesTab}</th>
                  <th style={{ width: 180 }}>Acciones</th>
                </tr>
              </thead>

              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      No hay registros.
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => (
                    <tr key={row[idField]}>
                      <td>{row[idField]}</td>
                      <td>{row[valueField] || "(Vacío)"}</td>
                      <td>
                        <Button
                          bsStyle="warning"
                          bsSize="xsmall"
                          onClick={() => this.editUbicacion(row)}
                          disabled={isUbicacionesLoading}
                          style={{ marginRight: 6 }}
                        >
                          Editar
                        </Button>

                        <Button
                          bsStyle="danger"
                          bsSize="xsmall"
                          onClick={() => this.deleteUbicacion(row)}
                          disabled={isUbicacionesLoading}
                        >
                          Eliminar
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>

        <Modal.Footer className="tags-modal-footer">
          <Button onClick={this.closeUbicacionesModal} disabled={isUbicacionesLoading}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderUbicacionPickerModal() {
    const { showUbicacionPicker, pickerOptions, pickerIndex, queue } = this.state;
    const fila = pickerIndex !== null && pickerIndex !== undefined ? queue?.[pickerIndex] : null;

    return (
      <Modal show={showUbicacionPicker} onHide={this.closeUbicacionPicker} dialogClassName="modal-wide-tags">
        <Modal.Header closeButton className="tags-modal-header">
          <Modal.Title className="tags-modal-title-center">Elegir ubicación existente</Modal.Title>
        </Modal.Header>

        <Modal.Body className="tags-modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {fila && (
            <p style={{ fontSize: 12, color: "#304255", marginBottom: 10 }}>
              Artículo <b>{fila.ItemCode}</b> — Almacén <b>{fila.Almacen || "(sin almacén)"}</b>.
              Seleccioná una de las ubicaciones ya registradas para evitar crear un tag duplicado.
            </p>
          )}

          <div className="queue-table-wrap" style={{ maxHeight: 360, overflowY: "auto" }}>
            <Table condensed hover bordered className="queue-table" style={{ marginBottom: 0 }}>
              <thead>
                <tr>
                  <th>Tag</th>
                  <th>Ubicación</th>
                  <th>Estante</th>
                  <th>Sección</th>
                  <th>Nivel</th>
                  <th style={{ width: 120 }}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {(pickerOptions || []).length === 0 ? (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      No hay ubicaciones registradas.
                    </td>
                  </tr>
                ) : (
                  (pickerOptions || []).map((t) => (
                    <tr key={t.number_tag}>
                      <td>{t.number_tag}</td>
                      <td>{t.location_desc_tag || this.buildLocationDescTag(t.Estante, t.Seccion, t.Nivel)}</td>
                      <td>{t.Estante || ""}</td>
                      <td>{t.Seccion || ""}</td>
                      <td>{t.Nivel || ""}</td>
                      <td>
                        <Button bsStyle="success" bsSize="xsmall" onClick={() => this.selectUbicacionFromPicker(t)}>
                          Seleccionar
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </Modal.Body>

        <Modal.Footer className="tags-modal-footer">
          <Button onClick={this.closeUbicacionPicker}>Cerrar</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { isLoading, message } = this.state;

    return (
      <div className="content tags-page-content" style={{ textAlign: "center", alignItems: "center" }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="TAGS"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    <div className="tags-page-toolbar">
                      <p style={style.errorMessage}>{message}</p>

                      <div className="tags-page-actions">
                        <Button bsStyle="warning" onClick={this.openUbicacionesModal}>
                          Administrar Ubicaciones
                        </Button>

                        <Button bsStyle="success" onClick={this.openCreateModal}>
                          Nuevo Tag
                        </Button>

                        <Button bsStyle="primary" onClick={this.loadData}>
                          Recargar
                        </Button>

                        <Button bsStyle="default" onClick={this.downloadExcel}>
                          Descargar Excel
                        </Button>
                      </div>
                    </div>

                    {this.renderGrid()}
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>

        {isLoading && <Loading />}
        {this.renderCreateModal()}
        {this.renderUbicacionesModal()}
        {this.renderUbicacionPickerModal()}
      </div>
    );
  }
}

export default Tags;

const style = {
  errorMessage: {
    fontWeight: "bold",
    fontSize: "12px",
    minHeight: "16px",
    color: "#c0392b",
    margin: 0,
    textAlign: "left",
  },
  ColorCell: {
    textAlign: "center",
    backgroundColor: "#dddddd",
    border: "0px solid",
    color: "#000",
  },
};

function xOrEmpty(v) {
  return v || "";
}